export default __webpack_public_path__ + "static/media/bell.60a61cb4.svg";